<template>
  <div class="modal-column">
    <!--    <div class="px-16px py-8px ">
          <Checkbox v-model="merge">合并凭证</Checkbox>
          <Checkbox v-if="merge" class="inline ml-16px" :datas="{mergeSel:'合并相同的收支科目',mergeOther:'合并相同的对方科目'}" v-model="mergeType"/>
          <Checkbox v-model="imc" class="ml-16px">智能匹配往来单位</Checkbox>
        </div>-->
    <div class="px-16px py-8px ">
      <!-- 9985 -->
      <Button @click="doAuto">智能匹配辅助核算</Button>
    </div>    
    <div class="flex bg-green-200 px-16px">
      <div class="w-300px p-8px">日记账</div>
      <div class="flex-1 p-8px">凭证预览</div>
    </div>
    <div style="display: flex;flex-direction: column; color: red;margin:5px 0;padding: 0 16px;">
      <span>{{hint1}}</span>
      <span>{{hint2}}</span>
      <span>{{hint3}}</span>
    </div>
    <div class="flex-1 h-0px overflow-y" style="padding: 0 16px">
      <template v-for="item in records">
        <div class="flex">
          <div class="w-300px">
            <div style="height: 137px;" class="border mb-8px" :key="item.id">
              <div class="bg-gray2-color p-8px">{{ item.serialNumber }}</div>
              <div class="p-8px text-12px">
                <div style="margin-top: 8px;">日期：{{ item.billDate }}</div>
                <div style="margin-top: 8px;" class="my-8px">收支类型：{{ item.ioTypeValue }}</div>
                <div style="margin-top: 8px;" class="my-8px">摘要：{{ item.digest }}</div>
                <div>{{ item.ioType === '收' ? '收入' : '支出' }}：{{ numFormat(item.debit || item.credit) }}</div>
              </div>
            </div>
          </div>
          <div class="flex-1 ml-8px">
            <template v-if="voucherList[item.id]">
              <div class="p-8px bg-gray3-color" style="display: flex;justify-content: space-between;">
                <div>
                  <span class="mr-26px">日期：{{ voucherList[item.id].voucherDate }}</span> 
                  <span>凭证字号：{{ voucherList[item.id].word }}-{{ voucherList[item.id].code }}</span>
                </div>  
                <div>
                  <span class="span fa fa-reply" style="cursor: pointer;font-size: 14px;padding-left: 6px;" @click="edit(voucherList[item.id],item.id)">修改</span>
                  <span class="span fa fa-remove" style="cursor: pointer;font-size: 14px;padding-left: 6px;" @click="removeRow(item.id)">移除</span>
                </div>
              </div>
              <vxe-table :data="voucherList[item.id].details" :show-header="false" show-footer :footer-method="footerMt">
                <vxe-column field="summary"/>
                <vxe-column field="subjectName">
                   <!-- 9985 -->
                   <template #default="{row}">
                    <block v-if="row.auxiliary && row.auxiliary.length > 0 && row.auxiliaryAccounting">
                      <div v-if="row.auxiliary.length !== row.auxiliaryAccounting.length" style="color: red">{{ row.subjectName }}</div>
                      <div v-else="row.auxiliary.length == row.auxiliaryAccounting.length" style="color: black">{{ row.subjectName }}</div>
                    </block>
                    <block v-else>
                      <div v-if="msgSubjectIdList.includes(row.subjectId)" style="color: red">{{ row.subjectName }}</div>
                      <div v-else="msgSubjectIdList.includes(row.subjectId)" style="color: black">{{ row.subjectName }}</div>
                    </block>
                    <!-- <div v-if="msgSubjectIdList.includes(row.subjectId) || row.auxiliary.length !== row.auxiliaryAccounting.length" style="color: red">{{ row.subjectName }}</div>
                    <div v-else="msgSubjectIdList.includes(row.subjectId) || row.auxiliary.length == row.auxiliaryAccounting.length" style="color: black">{{ row.subjectName }}</div> -->
                  </template>
                </vxe-column>
                <vxe-column field="debitAmount" align="right" formatter="toMoney"/>
                <vxe-column field="creditAmount" align="right" formatter="toMoney"/>
              </vxe-table>
            </template>
            <template v-else>
              请先设置凭证模板
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="modal-column-between">
      <Button :loading="loading" @click="$emit('close')" icon="fa fa-close">取消</Button>
      <Button :loading="loading" @click="doSubmit" color="primary" icon="fa fa-save">保存</Button>
    </div>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
	name: "CashierJournalVoucherPreview"
}
</script>

<script setup>
import {layer} from "@layui/layer-vue";
import { h } from "vue";
import {ref, toRefs, getCurrentInstance,nextTick} from "vue";
import {useStore} from "vuex";
import CashierIoType from "@/api/CashierIoType";
import {groupBy, remove} from "xe-utils";
import manba from "manba";
import voucher from "@/api/voucher";
import cashierJournal from "@/api/CashierJournal";
import {confirm, message} from "heyui.ext";
import setting from "@/api/setting";
import VoucherForm from "@/views/voucher/VoucherForm.vue";

const store = useStore();
const {appContext} = getCurrentInstance();
const props = defineProps(['records', 'account',"deptOptions", "projectOptions","assistingAccountingAll"]);///jiaru9985
const emits = defineEmits(['success', 'close']);
const {records, account,deptOptions,projectOptions,assistingAccountingAll} = toRefs(props);///jiaru9985
const loading = ref(false);
const merge = ref(false);
const imc = ref(false);
const voucherList = ref({});
const mergeType = ref(['mergeSel', 'mergeOther']);
const gp = appContext.config.globalProperties;
const subjectList = ref([]);
const hint1 = ref('');
const hint2 = ref('');
const hint3 = ref('');
const msgSubjectNameList = ref([]);
const msgSubjectIdList = ref([]);


const doAuto = () =>{
  confirm({
		content: `智能匹配辅助核算，将从收支记录中提取部门，项目，客户，供应商，职员；如存在未设置的仍需自行选择！`,
		onConfirm: () => {
			// console.log(records.value);
      // console.log(voucherList.value);
      // console.log(msgSubjectNameList.value,msgSubjectIdList.value)
      for (let key in voucherList.value) {
        //每个凭证对象
        let item = voucherList.value[key];
        item.details.forEach(val => {
          let foundSubject = subjectList.value.find(subject => subject.id === val.subjectId);
          if(foundSubject.enableAuxiliary || foundSubject.auxiliaryAccounting.length > 0){
            console.log(foundSubject,"++",item.journalId)
            let journalId = records.value.find(journal => journal.id === item.journalId);
            console.log("找到的记录",journalId)
            console.log("这个科目核算了那些辅助项目？",foundSubject.auxiliaryAccounting)
            //根据科目核算的项目，去收支记录中检测，有没有符合匹配的记录
            val.auxiliary = []
            val.auxiliaryAccounting = foundSubject.auxiliaryAccounting
            foundSubject.auxiliaryAccounting.forEach(auxiliary => {
              console.log(auxiliary)
              if (auxiliary === "3") {
                  // 部门
                  console.log(deptOptions.value, "我是3");
                  let dept = deptOptions.value.find(dept => dept.key == journalId.deptCategoryDetailsId);
                  if(dept == null){
                    return;
                  }
                  dept.id = dept.key
                  dept.type = "DEPARTMENT"
                  dept.name = dept.title
                  dept.categoryType = "DEPARTMENT"
                  dept.categoryId = dept.accountingCategoryId
                  val.auxiliary.push(dept);
              } else if (auxiliary === "5") {
                  // 项目
                  console.log(projectOptions.value, "我是5");
                  let proj = projectOptions.value.find(proj => proj.key == journalId.projectCategoryDetailsId);
                  if(proj == null){
                    return;
                  }
                  proj.id = proj.key
                  proj.type = "PROJECT"
                  proj.categoryType = "PROJECT"
                  proj.name = proj.title
                  proj.categoryId = proj.accountingCategoryId
                  val.auxiliary.push(proj);
              } else {
                // 其他情况
                if (journalId.accountingCategoryId == auxiliary) {
                  console.log("我是其他");//assistingAccountingAll
                  let accounting = assistingAccountingAll.value.find(accounting => accounting.key == journalId.accountingCategoryDetailsId);
                  if(accounting == null){
                    return;
                  }
                  if(auxiliary == "0"){
                    accounting.type = "CUSTOMER"
                    accounting.categoryType = "CUSTOMER"
                  }else if(auxiliary == "1"){
                    accounting.type = "VENDOR"
                    accounting.categoryType = "VENDOR"
                  }else if(auxiliary == "2"){
                    accounting.type = "EMPLOYEE"
                    accounting.categoryType = "EMPLOYEE"
                  }else{
                    return;
                  }
                  accounting.id = accounting.key
                  accounting.name = accounting.title
                  accounting.categoryId = accounting.accountingCategoryId
                  val.auxiliary.push(accounting);
                }
              }
            })
          }
        })
      }
      console.log(voucherList.value)
      checkSubject();
		}
	})
}

const removeRow = (id) =>{
  if(records.value.length > 1){
    records.value.forEach((item, index) => {
      if(item.id == id){
        records.value.splice(index, 1)
      }
    })
    delete voucherList.value[id];
    // generateCredentials();
  }else{
    message({
				type:'warn',
				text: `至少保留一条记录！`
			});
  }
}

const edit = (data,id) =>{
  let editCashierVoucherData = JSON.parse(JSON.stringify(data)); ;
  // console.log(data)
  editCashierVoucherData.details.forEach(val => {
    let foundSubject = subjectList.value.find(subject => subject.id === val.subjectId);
    val.subject = foundSubject;
    val.balanceDirection = foundSubject.balanceDirection;
      val.debitAmount = val.debitAmount ? val.debitAmount : 0;
      val.creditAmount = val.creditAmount ? val.creditAmount : 0 ;
      val.isCarry = true;
      val.originalCreditAmount = val.creditAmount;
      val.originalDebitAmount = val.debitAmount;
      val.subjectType = foundSubject.type;
      val.incOrcash = true;//给src\components\VoucherTable\VTableSubject.vueconst loadCurrency 做判断用
  })
  let layerId = layer.drawer({
    title: "资金生成凭证",
    shadeClose: false,
    zIndex: 999,
    area: ['1120px', '100vh'],
    content: h(VoucherForm, {
      editCashierVoucher:true,
      editCashierVoucherData: editCashierVoucherData,
      onSuccess: (data) => {
        let array = JSON.parse(data)
        array.forEach(val => {
          val.subjectName = val.subject.code + '-' + val.subject.fullName;
        })
        voucherList.value[id].details = array;
        console.log("888888",voucherList.value)
        checkSubject();
        layer.close(layerId);
      },
      onClose: () => {
        layer.close(layerId);
      }
    })
  })
}

const checkSubject = () =>{
  // console.log('检测科目',voucherList.value)
  setting.subject.listAll().then(({data}) => {
    subjectList.value = data;  
    let subjectNameList = [];  
    let subjectIdList = [];  
    let msg1 = '';  
    let msg2 = '';  
    let msg3 = '';  
      
    for(let key in voucherList.value){  
      voucherList.value[key].details.forEach(val => {  
        let foundId = subjectList.value.find(subject => subject.id === val.subjectId);  
        console.log("这个数据",foundId,val)
          
        if(foundId && !foundId.leaf){  
          let subjectName = `${foundId.code}-${foundId.name}`;  
          if (!subjectNameList.includes(subjectName)) {  
            msg1 += subjectName + '，';  
            subjectNameList.push(subjectName);  
            subjectIdList.push(foundId.id);
          }  
        }  
          
        if(foundId && foundId.currencyAccounting.length > 0 && !val.exchangeRate && !val.amountFor){  
          let subjectName = `${foundId.code}-${foundId.name}`;  
          if (!subjectNameList.includes(subjectName)) {  
            msg2 += subjectName + '，';  
            subjectNameList.push(subjectName);  
            subjectIdList.push(foundId.id);
          }  
        }  
          
        if(foundId && foundId.auxiliaryAccounting.length > 0 && (!val.auxiliary || foundId.auxiliaryAccounting.length !== val.auxiliary.length)){  //9985
          let subjectName = `${foundId.code}-${foundId.name}`;  
          if (!subjectNameList.includes(subjectName)) {  
            msg3 += subjectName + '，';  
            subjectNameList.push(subjectName);  
            subjectIdList.push(foundId.id);
          }  
        }  
      });  
    }  
      
    // 去除最后一个逗号，并添加提示信息  
    // else{this.hint1，使已经没问题的，置空  
    if(msg1.length){  
      msg1 = msg1.slice(0, -1) + '，不是明细科目，请重新设置凭证模板或手动修改科目!';  
      hint1.value = msg1;  
    }else{
      hint1.value = '';
    }
      
    if(msg2.length){  
      msg2 = msg2.slice(0, -1) + '，是外币核算科目，请手动填写汇率!';  
      hint2.value = msg2;  
    } else{
      hint2.value = '';
    } 
      
    if(msg3.length){  
      msg3 = msg3.slice(0, -1) + '，是辅助核算科目，请手动选择核算的项目!';  
      hint3.value = msg3;  
    } else{
      hint3.value = '';
    }   
      
    msgSubjectNameList.value = subjectNameList;
    msgSubjectIdList.value = subjectIdList;
  })
}

const generateCredentials = () =>{
    CashierIoType.templateList(account.value.type).then(async ({data}) => {
    console.log(data)
    //jxd 修改模版中的现金或银行账号，使之和当前生成凭证的科目一致,因为绑定的科目，不一定是一级科目
    data.forEach(val => {
      if(val.subjectTitle == '1001-库存现金' || val.subjectTitle == '1002-银行存款' || val.subjectTitle == '101-库存现金' || val.subjectTitle == '102-银行存款' || val.subjectTitle == '101-现金'){
        val.subjectTitle = account.value.subjectCode + '-' + account.value.subjectName
        val.subjectId = account.value.subjectId
      }
    })
    const templateMap = groupBy(data, val => val.type + "-" + val.ioTypeId);
    console.log("模版",templateMap)
    const voucherDate = manba(store.state.currentAccountSets.currentAccountDate).endOf(manba.MONTH).format();
    const codeMap = {};
    for (const row of records.value) {
      const template = templateMap[row.ioType + "-" + row.ioTypeId];
      if (template && template.length) {
        //获得凭证号
        let lastCode = codeMap[template[0].word];
        if (!lastCode) {
          const results = await voucher.loadCode({word: template[0].word, currentAccountDate: row.billDate})
          codeMap[template[0].word] = results.data;
          lastCode = results.data;
        }
        const rows = [];
        let debitAmount = 0, creditAmount = 0;
        //凭证外层数据
        const voucherData = {word: template[0].word, code: lastCode, voucherDate:row.billDate};
        //凭证内层数据
        template.forEach(it => {
          console.log("it数据",it);
          const item = {
            summary: row.digest,
            subjectName: it.subjectTitle,
            subjectId: it.subjectId,
            currencyId: store.getters.localCurrency.id,
          };
          let amount = row.debit || row.credit;
          if (it.direction === '借') {
            item.debitAmount = amount;
            debitAmount += amount;
          } else {
            item.creditAmount = amount;
            creditAmount += amount;
          }
          rows.push(item)
        })
        voucherData.journalId = row.id;
        voucherData.debitAmount = debitAmount;
        voucherData.creditAmount = creditAmount;
        voucherData.details = rows;
        voucherList.value[row.id] = voucherData;
        codeMap[template[0].word] = lastCode + 1;
      }
    }
    console.log("99966",voucherList.value)
    //检测科目是否是末级科目，是否辅助核算等
    checkSubject();
  })
}
generateCredentials();

const footerMt = ({data}) => {
	const debitAmount = data.reduce((t, r) => t + (r.debitAmount || 0), 0)
	const creditAmount = data.reduce((t, r) => t + (r.creditAmount || 0), 0)

	return [["合计", gp.dxMoney(debitAmount), gp.numFormat(debitAmount), gp.numFormat(creditAmount)]]
}

const doSubmit = () => {
  //jxd保存前科目检测
	if (Object.values(voucherList.value).length) {
    let flg = true;
    for(let key in voucherList.value){
      console.log(key)
      voucherList.value[key].details.forEach(item =>{
        if(msgSubjectIdList.value.includes(item.subjectId)){
          flg = false
        }
      })
    }
    if(flg){
      loading.value = true;
      cashierJournal.generateVoucher(Object.values(voucherList.value)).then(() => {
        emits('success');
      }).finally(() => loading.value = false)
    }else{
      message.warn("异常科目还没有修改完成，请按红字提示修改后再试！")
    }
	}
}
</script>